import { StoreModule } from '@ngrx/store';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { baseSharedReducer } from '../../_store/reducers';
import { baseSharedEffects } from '../../_store/effects';

@NgModule({
  imports: [
    StoreModule.forFeature('shared', baseSharedReducer.baseSharedReducer),
    EffectsModule.forFeature([baseSharedEffects.BaseSharedEffects]),
  ],
})
export class BaseSharedStoreModule {
  constructor(@Optional() @SkipSelf() parent?: BaseSharedStoreModule) {
    if (parent) throw new Error('Import BaseSharedStoreModule only once');
  }
}
